<template>
  <div class="card">
    <NuxtLinkLocale :to="`/explore/detail/${slug}`" class="card__image">
      <ElementsImage v-bind="image" />
    </NuxtLinkLocale>
    <div class="card__content">
      <NuxtLinkLocale :to="`/explore/${category}`" class="card__content-category">
        <template v-if="category === 'city'">Şehirdekiler</template>
        <template v-else-if="category === 'event'">Etkinlikler</template>
      </NuxtLinkLocale>
      <div class="card__content-heading">
        <NuxtLinkLocale :to="`/explore/detail/${slug}`" class="card__content-title">{{ title }}</NuxtLinkLocale>
        <div class="card__content-description">{{ description }}</div>
      </div>
      <NuxtLinkLocale class="card__content-link" :to="`/explore/detail/${slug}`">Devamını oku</NuxtLinkLocale>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    image?: any
    title?: string
    description?: string
    slug?: string
    category?: string
  }>()
</script>

<style lang="scss" scoped>
  .card {
    @apply flex flex-col gap-6;

    &__image {
      @apply flex relative w-full;
      padding-top: 60%;

      :deep(img) {
        @apply absolute inset-0 w-full h-full object-cover;
      }
    }
    &__content {
      @apply flex flex-col justify-center items-center text-center gap-4;

      &-category {
        color: #555;
        font-size: 10px;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: 1.65px;
        text-transform: uppercase;
      }
      &-heading {
        @apply flex flex-col items-center justify-center gap-3;
      }
      &-title {
        color: #000;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        letter-spacing: 1.92px;
      }
      &-description {
        @apply line-clamp-3;
        color: #555;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: 0.32px;
      }
      &-link {
        color: #282828;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 3px;
        text-transform: uppercase;
        text-decoration: underline;
        text-underline-offset: 5px;
        padding-bottom: 5px;
        width: fit-content;
        margin-top: 8px;
      }
    }

    @include media("lg") {
      @apply gap-4;

      &__content {
        @apply gap-3;

        &-category {
          font-size: 10px;
          line-height: 16px;
        }
        &-heading {
          @apply gap-1;
        }
        &-title {
          font-size: 20px;
          line-height: 28px;
        }
        &-description {
          font-size: 15px;
          line-height: 26px;
        }
        &-link {
          font-size: 13px;
          line-height: 15px;
        }
      }
    }
    @include media("md") {
      @apply gap-4;

      &__content {
        @apply gap-2;

        &-heading {
          @apply gap-1;
        }
        &-title {
          font-size: 18px;
          line-height: 24px;
          letter-spacing: 0.8px;
        }
        &-description {
          font-size: 14px;
          line-height: 22px;
        }
        &-link {
          font-size: 12px;
          line-height: 14px;
          letter-spacing: 1.8px;
        }
      }
    }
  }
</style>
